<template><div class="view">

	<fetching-content v-if="is_fetching_content" />
	<error-404 v-if="show_404" />	

	
	<main v-if="page && page_category == 'static' && content_type == 'blocks' ">
		
		<blocks v-if="!editing_blocks" :blocks="blocks" :metadata="blocks_metadata" />		
		<block-editor v-if="editing_blocks" :blocks="blocks" :route_name="$route.name" :page_slug="slug" @updated="blocksUpdated()" @onexit="blockEditorOnExit()" />

	</main>

	<main v-if="page && page_category == 'static' && content_type == 'text_image' ">

		<div class="page-headerimgs" v-if="page.galleryslides">			
			<centerfold-slides :slides="page.galleryslides" />
		</div>		

		<div class="page-content wysiwyg-content" v-if="page.textcols && page.textcols == '1col' && page.text_col1 " v-html="page.text_col1"></div>

		<div class="page-content"  v-if="page.textcols && page.textcols == '2col' && page.text_col1 && page.text_col2">			
			<div class="text-cols">
				<div class="text-col1 wysiwyg-content" v-html="page.text_col1"></div>
				<div class="text-col2 wysiwyg-content" v-html="page.text_col2"></div>
			</div>
		</div>
			
	</main>



	<main v-if="!is_site_am && page && page_category == 'newsarticle'">
				
		<div class="page-headerimgs" v-if="page.galleryslides">						
			<centerfold-slides :slides="page.galleryslides" />
		</div>
		
	</main>


	<main v-if="is_site_am && page && ( page_category == 'newsarticle' || page_category == 'artistgallery' )">

		<div>
			<div class="lbar">

				<div class="text wysiwyg-content" v-if="page.text_col1" v-html="page.text_col1" @click="handleDynamicHtmlClicks($event)"></div>

			</div>
			<div class="mbar">

				<div class="page-headerimgs" v-if="page.galleryslides">						
					<centerfold-slides :slides="page.galleryslides" :can-add-to-casting="true" />
				</div>

			</div>
		</div>
	
	</main>


</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'

import Blocks from '.././components/Blocks'
import BlockEditor from '.././views/admin/AdminBlockEditor'

import VideoEmbed from '.././components/VideoEmbed'
import CenterfoldSlides from '.././components/CenterfoldSlides'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		Blocks, BlockEditor, CenterfoldSlides, VideoEmbed, 	
	},

	data(){ return {
			
		show_404: false,

	}},

	computed: {

		slug(){ 
			var slug = this.route.path.replace('/','')
			if( this.is_site_am ) slug = slug.replace('artist/','')
			if( this.is_site_am && !slug ) slug = 'frontpage'
			return slug
		},

		page(){ return this.$store.state.loaded_page },
		
		page_category(){ 
			if( !this.page ) return
			return this.page.category
		},

		content_type(){
			if( !this.page ) return
			return this.page.content_type
		},

		blocks(){
			if( !this.$store.state.loaded_page ) return
			if( !this.$store.state.loaded_page.blocks ) return

			var blocks = this.$store.state.loaded_page.blocks

			if( !this.editing_blocks ) {

				blocks = helpers.blocks_filter_capbelowblock(blocks)
				blocks = helpers.blocks_filter_nohideblocks(blocks)

			}
			  
			return blocks
		},

		blocks_metadata(){
			return {				
				context: 'page-blocks',
				page_slug: this.slug,
			}
		},

	},

	methods: {

		load_page(){
			
			var _this = this

			this.$store.commit('set_is_site_while_fetching_content', this.$store.getters.is_site )
			this.$store.commit('set_loaded_page', undefined )

			var slug = this.slug
			if( this.is_site_am ) slug = 'a-management.eu/' + slug
			slug = slug.replace('a-management.eu/news/','news/')
			slug = slug.replace('a-management.eu/gallery/','gallery/')

			this.fetch( 'get_page', { slug:slug, realm:this.is_site }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.page ) {
					console.log('valid request, but missing data')												
					_this.show_404 = true
					return
				}

				_this.show_404 = false
				_this.$store.commit('set_loaded_page', output.data.page )
				_this.$store.commit('set_is_site_while_fetching_content', undefined )
				_this.setDocumentTitle( output.data.page.title )
				window.prerenderReady = true

				if( window.scoop_onLoadScrollTo ) {
					setTimeout(()=>{
						window.scrollTo(window.scoop_onLoadScrollTo.x, window.scoop_onLoadScrollTo.y)
						window.scoop_onLoadScrollTo = undefined
					}, 0)					
				}

				document.querySelector('body').classList.remove('page-newsarticle')
				document.querySelector('body').classList.remove('page-artistgallery')
				document.querySelector('body').classList.remove('page-static')
				document.querySelector('body').classList.add('page-'+_this.page_category)

				//document.body.classList.add('page-xxxxx'+)

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		
				_this.show_404 = true

			}})
				
		},

//---------------------------------------------------------------------------------------

		blocksUpdated(){
			//this.load_page()
		},

//---------------------------------------------------------------------------------------

		blockEditorOnExit(){
			console.log('block editor exit')
			this.load_page()
		},

//---------------------------------------------------------------------------------------

	},

	watch: {
		'$route' (to, from) {			
			this.load_page()
			//window.scrollTo( 0, 0 )
		}
	},

	mounted(){
		this.load_page()
	},

}
</script>



// WEBPACK FOOTER //
// src/views/Page.vue